/* TCC mobiel menu (sep 2026). Vangt de tik op de hamburger van het thema af (header-drawer summary) en opent
   dit paneel in plaats van het oude menu. Staat de sectie uit of is ze weg, dan werkt het oude menu gewoon.
   Meting: GA4 (gtag) events menu_open en menu_click (link_text, link_url, menu_section), Clarity-events en
   een DOM-event "tcc:menu" op document. */
(() => {
  if (customElements.get('tcc-mobile-menu')) return;
  const MQ = window.matchMedia('(max-width: 989px)');
  const FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {}
    try { if (typeof window.clarity === 'function') { window.clarity('event', name); if (params && params.menu_section) window.clarity('set', 'menu_section', params.menu_section); } } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('tcc:menu', { detail: Object.assign({ event: name }, params || {}) })); } catch (e) {}
  }

  class TccMobileMenu extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.tcc-mm__panel');
      this.main = this.querySelector('[data-tcc-view="main"]');
      this.sub = null;
      this.trigger = null;
      this.isOpen = false;
      this.enabled = this.dataset.enabled === 'true';
      this.onDocClick = this.onDocClick.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onPageShow = e => { if (e.persisted) this.close(true); };
      this.onMq = () => { if (!MQ.matches && this.isOpen) this.close(true); };
      this.onPointer = e => { if (e.target && e.target.closest && e.target.closest('header-drawer summary') && MQ.matches) this.warm(); };
      if (this.enabled) {
        document.addEventListener('click', this.onDocClick, true);
        document.addEventListener('pointerdown', this.onPointer, true);
        // beelden pas laden als de pagina klaar is (alleen mobiel/tablet), zodat de eerste weergave niet trager wordt
        const idle = cb => (window.requestIdleCallback ? window.requestIdleCallback(cb, { timeout: 3000 }) : setTimeout(cb, 200));
        const later = () => setTimeout(() => idle(() => { if (MQ.matches) this.warm(); }), 2500);
        if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
      }
      this.addEventListener('click', this.onClick.bind(this));
      window.addEventListener('pageshow', this.onPageShow);
      if (MQ.addEventListener) MQ.addEventListener('change', this.onMq);
      this.setHidden(true);
      if (window.Shopify && window.Shopify.designMode) this.bindEditor();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick, true);
      document.removeEventListener('pointerdown', this.onPointer, true);
      document.removeEventListener('keydown', this.onKey);
      window.removeEventListener('pageshow', this.onPageShow);
      if (MQ.removeEventListener) MQ.removeEventListener('change', this.onMq);
      if (this.isOpen) this.unlockScroll();
    }

    hamburger() { return document.querySelector('header-drawer summary'); }

    // paneel in de layout zetten (nog onzichtbaar) zodat de beelden alvast laden
    warm() {
      if (this.warmed) return;
      this.warmed = true;
      this.classList.add('is-ready');
      this.main.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
    }

    // tik op de hamburger van het thema: oude menu niet openen, dit wel
    onDocClick(e) {
      const s = e.target && e.target.closest ? e.target.closest('header-drawer summary') : null;
      if (!s || !MQ.matches) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (this.isOpen) this.close(); else this.open(s);
    }

    onClick(e) {
      if (e.target.closest('[data-tcc-close]')) { this.close(); return; }
      if (e.target.closest('[data-tcc-back]')) { this.closeSub(); return; }
      const opener = e.target.closest('[data-tcc-open]');
      if (opener) { this.openSub(opener.dataset.tccOpen, opener); return; }
      const a = e.target.closest('a[href]');
      if (a) {
        const label = (a.getAttribute('aria-label') || a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
        track('menu_click', { link_text: label, link_url: a.href, menu_section: a.dataset.tccSec || '' });
        if (a.getAttribute('href').charAt(0) === '#') this.close();
      }
    }

    setHidden(hidden) {
      this.panel.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      if ('inert' in this.panel) this.panel.inert = hidden;
    }

    lockScroll() { document.body.classList.add('overflow-hidden-tablet'); }
    unlockScroll() { document.body.classList.remove('overflow-hidden-tablet'); }

    open(trigger) {
      if (this.isOpen) return;
      this.isOpen = true;
      this.trigger = trigger || this.hamburger();
      this.warm();
      this.classList.add('has-opened');
      this.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
      void this.panel.offsetWidth; // eerst layout, dan pas de schuifanimatie starten
      this.setHidden(false);
      this.classList.add('is-open');
      if (this.trigger) { this.trigger.setAttribute('aria-expanded', 'true'); this.trigger.setAttribute('aria-controls', 'TccMobileMenu'); }
      this.lockScroll();
      document.addEventListener('keydown', this.onKey);
      const close = this.main.querySelector('[data-tcc-close]');
      setTimeout(() => close && close.focus({ preventScroll: true }), 60);
      track('menu_open', {});
    }

    close(instant) {
      if (!this.isOpen) return;
      this.isOpen = false;
      if (instant) this.classList.add('tcc-mm--instant');
      this.classList.remove('is-open');
      this.setHidden(true);
      this.unlockScroll();
      document.removeEventListener('keydown', this.onKey);
      if (this.trigger) { this.trigger.setAttribute('aria-expanded', 'false'); if (!instant) this.trigger.focus({ preventScroll: true }); }
      const reset = () => { this.closeSub(true); this.querySelectorAll('[data-tcc-scroll]').forEach(el => { el.scrollTop = 0; }); this.classList.remove('tcc-mm--instant'); };
      if (instant) reset(); else setTimeout(reset, 360);
    }

    openSub(id, opener) {
      const view = this.querySelector(`[data-tcc-view="${id}"]`);
      if (!view) return;
      if (this.sub && this.sub !== view) this.closeSub(true);
      this.sub = view; this.subOpener = opener || null;
      view.inert = false;
      view.classList.add('is-active');
      this.panel.classList.add('in-sub');
      this.main.inert = true;
      if (opener) opener.setAttribute('aria-expanded', 'true');
      const back = view.querySelector('[data-tcc-back]');
      setTimeout(() => back && back.focus({ preventScroll: true }), 60);
      track('menu_submenu', { menu_section: (opener && opener.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60) });
    }

    closeSub(instant) {
      const view = this.sub;
      if (!view) return;
      this.panel.classList.remove('in-sub');
      view.classList.remove('is-active');
      view.inert = true;
      this.main.inert = false;
      if (this.subOpener) { this.subOpener.setAttribute('aria-expanded', 'false'); if (!instant) this.subOpener.focus({ preventScroll: true }); }
      this.sub = null; this.subOpener = null;
      if (!instant) setTimeout(() => { const b = view.querySelector('[data-tcc-scroll]'); if (b) b.scrollTop = 0; }, 340);
    }

    onKey(e) {
      if (e.key === 'Escape') { if (this.sub) this.closeSub(); else this.close(); return; }
      if (e.key !== 'Tab') return;
      const view = this.sub || this.main;
      const items = [...view.querySelectorAll(FOCUSABLE)].filter(el => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!view.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    }

    // themaeditor: sectie of blok selecteren toont het menu (en het juiste submenu)
    bindEditor() {
      const mine = e => this.closest('.shopify-section') && e.target && (e.target === this.closest('.shopify-section') || e.target.contains(this));
      document.addEventListener('shopify:section:select', e => { if (mine(e) && MQ.matches) this.open(this.hamburger()); });
      document.addEventListener('shopify:section:deselect', e => { if (mine(e)) this.close(true); });
      document.addEventListener('shopify:block:select', e => {
        if (!this.contains(e.target) || !MQ.matches) return;
        this.open(this.hamburger());
        const view = e.target.closest('[data-tcc-view]');
        const opener = e.target.closest('[data-tcc-open]');
        if (view && view.dataset.tccView !== 'main') this.openSub(view.dataset.tccView);
        else if (opener) this.openSub(opener.dataset.tccOpen, opener);
        else if (this.sub) this.closeSub(true);
      });
    }
  }
  customElements.define('tcc-mobile-menu', TccMobileMenu);
})();
